const validateCompanyUrlUniqueness = () => {
  $('.jsRegUserURL').on('change', () => {
    const urlDomain = $('.jsRegUserURL').val().replace(/^.*:\/\//, '').replace(/\/.*$/, '');
    const urls = gon.url_domains;
    const urlErrorMessage = 'あなたの会社はすでに登録している可能性があります。アカウントが重複して登録された場合は、削除されますのでご注意ください。';
    $('div#URLError').remove();
    if (urls.indexOf(urlDomain) >= 0) {
      $('.jsRegUserURL').after(`<div id="URLError" class="p_flashBox isError" style="margin-top: 10px;">${  urlErrorMessage  }</div>`);
    }
  });
};
  
export default validateCompanyUrlUniqueness;
  